export const getKeyPressFromStr = (rawKeyPresses: string): string | undefined => {
  const normalized = rawKeyPresses.trim();

  if ([undefined, null, ''].includes(normalized)) {
    return undefined;
  }

  if (['0', 'zero'].includes(normalized)) {
    return '0';
  }

  if (['1', 'one'].includes(normalized)) {
    return '1';
  }

  if (['2', 'two'].includes(normalized)) {
    return '2';
  }

  if (['3', 'three'].includes(normalized)) {
    return '3';
  }

  if (['4', 'four'].includes(normalized)) {
    return '4';
  }

  if (['5', 'five'].includes(normalized)) {
    return '5';
  }

  if (['6', 'six'].includes(normalized)) {
    return '6';
  }

  if (['7', 'seven'].includes(normalized)) {
    return '7';
  }

  if (['8', 'eight'].includes(normalized)) {
    return '8';
  }

  if (['9', 'nine'].includes(normalized)) {
    return '9';
  }

  return undefined;
};
